import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  LineElement,
  BarElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { useContext, useEffect, useState } from "react";
import { Row, Col, Card, Skeleton } from "antd";
import { Line, Bar } from "react-chartjs-2";
import { useHttp } from "../../../utils/DataHendler";
import { ReportStructure } from "./patrolstatistic";

// Registrasi elemen-elemen Chart.js yang diperlukan
ChartJS.register(
  CategoryScale,
  LinearScale,
  LineElement,
  BarElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);

export const StatisticsVisitor = () => {
  const { getData } = useHttp();
  const [dataStatistic, setStatistic] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getStatistic();
  }, []);

  const getStatistic = async () => {
    setLoading(true);
    try {
      const response = await getData("/statistic/monthly", {}, true);
      setStatistic(response.data);
    } catch (error) {
      console.error("Error fetching statistics:", error);
    } finally {
      setLoading(false);
    }
  };

  // Data untuk grafik akumulasi pengunjung harian (Area Chart)
  const chartDataByDate = {
    labels: dataStatistic.by_date?.map((item) => item.date) || [],
    datasets: [
      {
        label: "Accumulated Visitors per Day",
        data: dataStatistic.by_date?.map((item) => item.total_visitors) || [],
        backgroundColor: "rgba(24, 144, 255, 0.2)",
        borderColor: "#1890ff",
        borderWidth: 2,
        pointBackgroundColor: "#1890ff",
        pointRadius: 4,
        fill: true,
      },
    ],
  };

  // Data untuk grafik jumlah pengunjung berdasarkan departemen (Bar Chart)
  const chartDataByDepartment = {
    labels: dataStatistic.by_department?.map((item) => item.department) || [],
    datasets: [
      {
        label: "Accumulated visitors per Department",
        data:
          dataStatistic.by_department?.map((item) => item.total_visitors) || [],
        backgroundColor: "#52c41a",
        borderColor: "#52c41a",
        borderWidth: 1,
      },
    ],
  };

  // Konfigurasi opsional untuk chart
  const chartOptions = {
    responsive: true,
    animation: {
      duration: 1000, // Animasi durasi 1 detik
      easing: "easeInOutQuad", // Efek animasi
    },
    plugins: {
      legend: {
        position: "top",
        labels: {
          color: "#333", // Warna teks legenda
          font: {
            size: 14, // Ukuran font legenda
          },
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.dataset.label || "";
            const value = context.parsed.y || 0;
            return `${label}: ${value}`;
          },
        },
        backgroundColor: "#fff", // Latar belakang tooltip
        titleColor: "#333", // Warna judul tooltip
        bodyColor: "#666", // Warna isi tooltip
        borderColor: "#ddd", // Warna border tooltip
        borderWidth: 1,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          color: "#666", // Warna teks sumbu X
          font: {
            size: 12, // Ukuran font sumbu X
          },
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          color: "#f0f0f0",
        },
        ticks: {
          color: "#666", // Warna teks sumbu Y
          font: {
            size: 12, // Ukuran font sumbu Y
          },
        },
        title: {
          display: true,
          text: "Total",
          color: "#333", // Warna judul sumbu Y
          font: {
            size: 14, // Ukuran font judul sumbu Y
          },
        },
      },
    },
  };

  return (
    <>
    
    <div style={{ padding: "24px" }}>
      {/* Grafik Akumulasi Pengunjung Harian (Area Chart) */}
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={12}>
          <Card
            title="Daily Visitor Accumulation"
            style={{
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
              height: "100%",
            }}
          >
            {loading ? (
              <Skeleton active paragraph={{ rows: 4 }} />
            ) : (
              <Line data={chartDataByDate} options={chartOptions} />
            )}
          </Card>
        </Col>

        {/* Grafik Jumlah Pengunjung Berdasarkan Departemen (Bar Chart) */}
        <Col xs={24} sm={24} md={12}>
          <Card
            title="Number of Visitors by Department"
            style={{
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
              height: "100%",
            }}
          >
            {loading ? (
              <Skeleton active paragraph={{ rows: 4 }} />
            ) : (
              <Bar data={chartDataByDepartment} options={chartOptions} />
            )}
          </Card>
        </Col>
      </Row>
    </div>
    <div>
      <ReportStructure/>
    </div>
    </>
  );
};
